export const server = process.env.NODE_ENV === 'development' ? "http://localhost:8000" : "";
// export const server = "https://chroma.dev.svsticky.nl"